<template>
  <div class="hello">
    <el-pagination background layout="prev, pager, next" :total="total" style="margin-top: 60px;"
      @current-change="current_change">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    created() {

    },
    props: {
      total: {
        type: Number,
        require: true
      }
    },
    methods: {
      current_change(e) {

        this.$emit('currentchange', e)
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pagination.vue